module.exports = __webpack_public_path__ + "static/media/hair9.2a7ffc87.png";